import { render, staticRenderFns } from "./IQSearch.vue?vue&type=template&id=7076661c&scoped=true"
import script from "./IQSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./IQSearch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQSearch.vue?vue&type=style&index=0&id=7076661c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7076661c",
  null
  
)

export default component.exports